import { useState } from 'react'
import debounce from 'lodash.debounce'
import { useHost, useUpdateEffect } from '@10000/react'
import { DropDown } from './'

export const CitySearch = ({ value, onChange, onValidationChange, country, ...props }) => {
  const [initial, setInitial] = useState(true)
  const [placePredictions, setPlacePredictions] = useState([])
  const { getPlaces } = useHost()

  useUpdateEffect(() => {
    onChange('')
    setPlacePredictions([])
  }, [country])

  const formatCities = (value && initial)
    ? [{
        label: value,
        value
      }]
    : placePredictions.map(({ terms }) => ({
        label: terms[0].value,
        value: terms[0].value
      }))

  const citySearch = debounce(async search => {
    onValidationChange(false)
    setInitial(false)
    const newPlaces = await getPlaces(search, '(cities)', country)
    setPlacePredictions(newPlaces)
  }, 500, { leading: false, trailing: true })

  const addressSelected = city => {
    onValidationChange(true)
    if(onChange) {
      onChange(city)
    }
  }

  return (
    <DropDown
      search
      options={formatCities}
      value={value}
      onChange={addressSelected}
      onInputChange={citySearch}
      onInputBlur={() => setInitial(true)}
      {...props}
    />
  )
}